module.exports = __webpack_public_path__ + "static/media/slider1.37e104e4.jpg";